module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","msg":{"saved":"Your ticket has been saved."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateCoupon/locales/fr.json
// module id = 1714
// module chunks = 0